import { Empleado } from './../../general/models/empleado';
import { Observable } from 'rxjs';
import { Component, OnInit, Input, forwardRef, Output, EventEmitter, SimpleChanges, ViewChild, HostListener } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ModeloBase } from 'src/app/abm/models/modelobase';
import { NgSelectComponent } from '@ng-select/ng-select';

@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrls: ['./buscador.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => BuscadorComponent),
      multi: true
    }
  ]
})
export class BuscadorComponent implements OnInit, ControlValueAccessor {

  @ViewChild('buscadorSelect') buscadorSelect: NgSelectComponent;

  items: ModeloBase[];
  itemsCombo: any[];

  control: FormControl;
  private canvasMedicion: HTMLCanvasElement;

  @Output() seleccionado = new EventEmitter<ModeloBase>();

  @Input() required: boolean;

  @Input() bindValue : string = "id";

  @Input() clearable: boolean = true;

  @Input() hideCode: boolean = false;
  
  @Input()
  set datos(value: ModeloBase[]) {
    if (value) {
      this.itemsCombo = value.map(a => {
        if(a && a.hasOwnProperty('activo') && !a.activo)
          return;

        return {
          [this.bindValue] : this.bindValue != "id" && a[this.bindValue],
          id: a.id,
          nombre: this.descripcionItem(a)
        };
      }).filter(item => item);
    }

    this.items = value;

    // Falta informar?
    if (this.control.value) {
      const valor = this.control.value;
      const encontrado = this.items?.filter(a => '' + a[this.bindValue] === '' + valor);
      if (encontrado && encontrado.length && encontrado.length > 0) {
        if(encontrado[0] && encontrado[0].hasOwnProperty('activo') && !encontrado[0].activo){
          this.itemsCombo = [
            {
              [this.bindValue] : this.bindValue != "id" && encontrado[0][this.bindValue],
              id: encontrado[0].id,
              nombre: this.descripcionItem(encontrado[0])
            },
            ...this.itemsCombo
          ];
        }

        this.seleccionado.emit(encontrado[0]);
      }
    }
  }

  @Input()
  get disabled(): boolean { return this.control.disabled; }
  set disabled(value: boolean) {
    if (value) {
      this.control.disable();
    }
    else {
      this.control.enable();
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    this.control = new FormControl();

    this.control.valueChanges.subscribe(valor => {

      // Buscar el ID y asignarlo.
      if (this.items && this.items.length) {
        if (valor) {
          const encontrado = this.items.filter(a => '' + a[this.bindValue] === '' + valor);
          if(encontrado[0] && encontrado[0].hasOwnProperty('activo') && !encontrado[0].activo){
            this.itemsCombo = [
              {
                [this.bindValue] : this.bindValue != "id" && encontrado[0][this.bindValue],
                id: encontrado[0].id,
                nombre: this.descripcionItem(encontrado[0])
              },
              ...this.itemsCombo
            ];
          }

          this.seleccionado.emit(encontrado[0]);
        }
        else {
          this.seleccionado.emit(null);
        }
      }
    });
  }

  ngOnInit(): void {
  }

  @HostListener('window:resize')
  onResize(): void {
    this.ajustarPanelOpciones();
  }

  public ajustarPanelOpciones(): void {
    setTimeout(() => {
      if (!this.buscadorSelect || !this.buscadorSelect.isOpen) {
        return;
      }

      const panel = document.getElementById(this.buscadorSelect.dropdownId);
      const selectElement = this.buscadorSelect.element;

      if (!panel || !selectElement) {
        return;
      }

      const margenViewport = 8;
      const rectTrigger = selectElement.getBoundingClientRect();
      const anchoViewport = document.documentElement.clientWidth;
      const anchoMaximo = Math.max(0, anchoViewport - margenViewport * 2);
      const anchoBase = Math.min(rectTrigger.width, anchoMaximo);
      const anchoContenido = this.obtenerAnchoContenidoOpciones();
      const anchoPanel = Math.min(Math.max(anchoBase, anchoContenido), anchoMaximo);
      const espacioDerecha = anchoViewport - rectTrigger.left - margenViewport;
      const izquierdaPreferida = espacioDerecha >= anchoPanel ? rectTrigger.left : rectTrigger.right - anchoPanel;
      const izquierdaPanel = Math.max(
        margenViewport,
        Math.min(izquierdaPreferida, anchoViewport - anchoPanel - margenViewport)
      );

      panel.style.width = `${anchoPanel}px`;
      panel.style.minWidth = `${anchoPanel}px`;
      panel.style.maxWidth = `${anchoMaximo}px`;
      panel.style.left = `${izquierdaPanel}px`;
      panel.style.right = 'auto';

      if (panel.classList.contains('ng-select-top')) {
        panel.style.top = `${window.pageYOffset + rectTrigger.top - panel.offsetHeight}px`;
        panel.style.bottom = 'auto';
      }

      panel.style.visibility = 'visible';
    });
  }

  private obtenerAnchoContenidoOpciones(): number {
    const margenTexto = 56;
    const anchoMinimo = 200;
    const contexto = this.obtenerContextoMedicion();

    if (!contexto || !this.itemsCombo || !this.itemsCombo.length) {
      return anchoMinimo;
    }

    const anchoMayorTexto = this.itemsCombo.reduce((mayor, item) => {
      const nombre = item && item.nombre ? item.nombre : '';
      return Math.max(mayor, contexto.measureText(nombre).width);
    }, 0);

    return Math.ceil(anchoMayorTexto + margenTexto);
  }

  private obtenerContextoMedicion(): CanvasRenderingContext2D | null {
    if (!this.canvasMedicion) {
      this.canvasMedicion = document.createElement('canvas');
    }

    const contexto = this.canvasMedicion.getContext('2d');

    if (contexto) {
      const estilo = window.getComputedStyle(document.body);
      contexto.font = `${estilo.fontSize} ${estilo.fontFamily}`;
    }

    return contexto;
  }

  onChange = (_: any) => { };
  onTouched = () => { };

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['hideCode'] || changes['datos']) {
      if (this.items) {
        this.itemsCombo = this.items
          .filter((encontrado) => !encontrado.hasOwnProperty('activo') || encontrado.activo)
          .map((encontrado) => ({
            [this.bindValue]: this.bindValue != 'id' && encontrado[this.bindValue],
            id: encontrado.id,
            nombre: this.descripcionItem(encontrado),
          }));
      }
    }
  }

  @Input()
  public get value(): string | null {
    return this.control.value;
  }

  public set value(valor: string | null) {
    if (valor === '') {
      valor = null;
    }

    this.control.setValue(valor);
  }

  public descripcionItem(it: ModeloBase): string {
    if (it.hasOwnProperty('apellidos') && it.hasOwnProperty('nombres')) {
      const e = it as Empleado;
      return `${!this.hideCode ? it.codigo + ': ' : ''}${e.apellidos}, ${
        e.nombres
      }`;
    } else {
      return `${!this.hideCode ? it.codigo + ': ' : ''}${it.nombre}`;
    }
  }

  //////////////////////////////////
  // ControlValueAccessor interface
  //////////////////////////////////

  writeValue(opt: string | null): void {
    this.value = opt;
  }

  registerOnChange(fn: any): void {
    this.control.valueChanges.subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
